module.exports = __webpack_public_path__ + "static/media/mail2.196a5679.svg";